module.exports = __webpack_public_path__ + "static/media/replace-driver-red.859c9cf2.svg";